import { $isLinkNode } from '@lexical/link'
import { RangeSelection } from 'lexical'

import { getSelectedNode } from './getSelectedNode'

export function isLinkAndLastNode(rangeSelection: RangeSelection) {
  const node = getSelectedNode(rangeSelection)
  const parent = node.getParent()

  const contentSize = node?.getTextContentSize()
  const offset = rangeSelection.focus.offset

  const isUnique = contentSize === offset

  const isLastNode = isUnique && $isLinkNode(parent)

  const isLinkNode = $isLinkNode(parent) || $isLinkNode(node)

  return {
    isLinkNode,
    isLastNode,
  }
}
